import { defineMessages } from 'react-intl'

export default defineMessages({
  primary: {
    id: 'containers.EmbeddedCompanyPage.components.DefaultContacts.primary',
    defaultMessage: 'Primary',
  },
  secondary: {
    id: 'containers.EmbeddedCompanyPage.components.DefaultContacts.secondary',
    defaultMessage: 'Secondary',
  },
})
